import React from "react";
import PropTypes from "prop-types";
import ReviewStars from "../shared/review-stars";

// Heads up, This is a shared component across current PDP and Umiversal PDP
function ProductAggregateRating(props) {
  const { reviews } = props;
  return (
    <div className="flex items-center space-x-2">
      {reviews?.averageRating > 1 && (
        <span className="semibold text-md leading-none">{reviews?.averageRating / 2}</span>
      )}
      {reviews?.averageRating > 1 && <ReviewStars imageName={`BlackStars${Math.floor(props.reviews.averageRating)}`} />}
      {reviews?.count > 0 && (
        <span className="semibold leading-none  text-darkGray" itemProp="reviewCount">
          ({reviews.count} Reviews)
        </span>
      )}
    </div>
  );
}

export default ProductAggregateRating;

ProductAggregateRating.propTypes = {
  reviews: PropTypes.shape({
    averageRating: PropTypes.number,
    reviewCount: PropTypes.number,
    count: PropTypes.number,
  }),
};
